<template>
  <div class="ot-rule">
    <h3>
      <span>{{ $t('1600') }}</span>
    </h3>
    <el-form :model="dataForm" ref="dataForm" class="ot-rule-form">
      <div class="rules-wrap" v-for="(item, index) in arr" :key="index">
        <h1 class="label-title">
          <span>{{ $t(item.name) }}</span>
          <el-button v-if="!item.isEdit" type="primary" plain @click="clearHandle(item, true, index)">{{
            $t('71')
          }}</el-button>
          <template v-else>
            <el-button
              :loading="item.loading"
              type="primary"
              style="float: right; margin-left: 10px"
              plain
              @click="dataFormSubmit(item)"
              >{{ $t('67') }}</el-button
            >
            <el-button
              type="primary"
              plain
              style="float: right; margin-left: 10px"
              @click="clearHandle(item, false, index)"
            >
              {{ $t('66') }}
            </el-button>
          </template>
        </h1>
        <el-form-item>
          <transition-group name="slide-fade" tag="div">
            <!-- 展示 -->
            <div v-if="!item.isEdit" :key="index + 'p'">
              <div class="select-person">
                <p class="sun-title">{{ $t('1601') }}</p>
                <p>
                  {{ item.is_all === '2' ? $t('997') : $t('998') }}
                  <span v-if="item.is_all === '2'">({{ item.num || 0 }}) 人</span>
                </p>
              </div>
            </div>
            <!-- 编辑 -->
            <div :key="index + 'w'" v-else>
              <div class="select-person" v-if="item.is_allow == 1 && item.isEdit">
                <p class="sun-title">{{ $t('1601') }}</p>
                <el-radio-group v-model="item.is_all">
                  <!-- 所有人 -->
                  <el-radio label="1">{{ $t('998') }}</el-radio>
                  <!-- 指定人员 -->
                  <el-radio label="2">{{ $t('997') }}({{ item.num || 0 }})</el-radio>
                  <!-- 选择人员 -->
                  <el-button v-if="item.is_all === '2'" type="text" @click="openSel(index)">{{ $t('633') }}</el-button>
                </el-radio-group>
              </div>
            </div>
          </transition-group>
        </el-form-item>
        <!-- 出差打卡规则 -->
        <!-- <el-form-item :label="$t('出差打卡规则')">
          <el-radio-group v-if="item.isEdit">
            <el-radio label="1">{{ $t('532') }}</el-radio>
            <el-radio label="2">{{ $t('1626') }}</el-radio>
          </el-radio-group>
          <span v-else>{{ true ? '是' : '否' }}</span>
        </el-form-item> -->
      </div>
    </el-form>
    <!-- 组织架构 -->
    <Org
      v-if="visible"
      :visible.sync="visible"
      :defaultDepatment="form.department_list"
      :defaultEmployess="form.staff_list"
      @onConfirm="handlerSelected"
      isRegister="1"
    />
  </div>
</template>

<script>
// eslint-disable-next-line
import { getTravelFn, saveRuleFn, getDetailFn } from 'api/approval/config'
import Org from '@/components/organization'

export default {
  components: {
    Org
  },
  data() {
    return {
      form: {
        staff_list: [],
        department_list: []
      },
      visible: false,
      dataForm: {},
      arr: [],
      disabled: false,
      disabledForm: true,
      // 取消数据还原
      cancelData: null,
      // 当前操作项
      currrntIndex: null
    }
  },
  mounted() {
    this.getAll()
  },
  methods: {
    async getAll() {
      const res = await getTravelFn()
      this.$emit('clear-loading')
      const staffs = []
      this.arr = res.data.map(item => {
        item.staff_ids.forEach(item => {
          staffs.push({
            staff_id: item.staff_id,
            staff_name: item.staff_name,
            staff_name_en: item.staff_name_en,
            staff_name_secondary: item.staff_name_secondary,
            staff_name_th: item.staff_name_th,
            avatar_url: item.avatar_url
          })
        })
        item.staff_ids = staffs
        item.isEdit = false
        item.loading = false
        return item
      })
    },
    async dataFormSubmit(item) {
      item.loading = true
      await saveRuleFn(item)
      this.getAll()
    },
    async clearHandle(item, status, index) {
      this.arr[index].isEdit = status || false
      if (!status) this.getAll() // 获取详情
    },
    // 打开弹窗
    openSel(index) {
      this.visible = true
      this.currrntIndex = index
      // 当前选中项人员
      const currentSelect = this.arr[index]
      this.form.department_list = currentSelect.department_ids
      this.form.staff_list = currentSelect.staff_ids
    },
    handlerSelected(params) {
      const current = this.arr[this.currrntIndex]
      current.staff_ids = params.staffIds
      current.department_ids = params.depIds
      current.num = params.staffCount
      this.form.department_list = params.dept_list
      this.form.staff_list = params.staff_list
    },
    // 计算部门人数
    handlerDepPersonCount(dep) {
      let count = 0
      for (const i in dep) {
        count += dep[i].staff_count
      }
      return count
    }
  }
}
</script>

<style lang="scss" scoped>
.ot-rule-form {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  justify-content: space-evenly;
  width: calc(100% + 10px);
  /deep/ .el-form-item__label {
    display: block;
    width: 100%;
    text-align: left;
  }
  .rules-wrap {
    flex: 1;
    border: 1px solid $borderColor;
    min-width: 300px;
    margin: 0px 10px 15px 0;
    background: $appmainBg;
    .sun-title {
      line-height: 30px;
      color: rgba(black, 0.5);
    }
    .select-person {
      margin-top: 15px;
    }
    /deep/ .el-form-item {
      padding: 0 15px;
    }
    .label-title {
      margin: 0;
      padding: 13px 15px;
      border-bottom: 1px solid $borderColor;
      /deep/ .el-button {
        float: right;
        transform: translateY(-6px);
      }
    }
  }
}
</style>
